import React, { createContext, useContext, useState } from 'react';

// Create the Platform Context
const PlatformContext = createContext();

// Platform Provider component
export function PlatformProvider({ children }) {
  const [currentPlatform, setCurrentPlatform] = useState(null);
  const [platformData, setPlatformData] = useState({});

  const selectPlatform = (platformKey, data = {}) => {
    setCurrentPlatform(platformKey);
    setPlatformData(data);
    console.log(`Platform context: Selected ${platformKey}`, data);
  };

  const clearPlatform = () => {
    setCurrentPlatform(null);
    setPlatformData({});
    console.log('Platform context: Cleared platform selection');
  };

  const updatePlatformData = (newData) => {
    setPlatformData(prev => ({ ...prev, ...newData }));
    console.log('Platform context: Updated platform data', newData);
  };

  const contextValue = {
    currentPlatform,
    platformData,
    selectPlatform,
    clearPlatform,
    updatePlatformData
  };

  return (
    <PlatformContext.Provider value={contextValue}>
      {children}
    </PlatformContext.Provider>
  );
}

// Custom hook to use the Platform Context
export function usePlatform() {
  const context = useContext(PlatformContext);

  if (!context) {
    throw new Error('usePlatform must be used within a PlatformProvider');
  }

  return context;
}

export default PlatformContext;